import { render, staticRenderFns } from "./SmOwMenu.vue?vue&type=template&id=62e79c92&scoped=true&"
import script from "./SmOwMenu.vue?vue&type=script&lang=ts&"
export * from "./SmOwMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SmOwMenu.vue?vue&type=style&index=0&id=62e79c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e79c92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})
